import { DialogController } from 'aurelia-dialog';
import { autoinject } from 'aurelia-framework';
import { AsyncErrorHandler } from 'lib/ui';
import { SearchResult } from 'elements/search/search-input';
import { MooringExtraArticleItemDto } from 'models/mooring';
import { MooringOfferService, MooringComponentSearchHandler } from 'services/mooring';

export type ExtraArticleDialogArgs = {
  mooringId: number;
  existingExtraArticle?: MooringExtraArticleItemDto;
};

@autoinject
export class ExtraArticleDialog {
  protected mooringId!: number;
  protected isEdit = false;
  protected extraArticleId!: number;

  protected articleProductId!: number;
  protected articleProductName!: string;
  protected quantity!: number;
  protected comment?: string;

  constructor(
    protected element: Element,
    private dialogController: DialogController,
    private mooringOfferService: MooringOfferService,
    protected mooringComponentSearchHandler: MooringComponentSearchHandler
  ) {}

  activate(args: ExtraArticleDialogArgs) {
    this.mooringId = args.mooringId;

    if (args.existingExtraArticle) {
      this.isEdit = true;
      this.extraArticleId = args.existingExtraArticle.Id;
      this.quantity = args.existingExtraArticle.Quantity;
      this.comment = args.existingExtraArticle.Comment;
    }
  }

  protected onArticleSelected(result: SearchResult) {
    this.articleProductId = result.id as number;
    this.articleProductName = result.title;
  }

  @AsyncErrorHandler
  protected async onSave() {
    if (!this.isEdit && !this.articleProductId) return;
    if (!this.quantity || this.quantity <= 0) return;

    if (this.isEdit) {
      await this.mooringOfferService.updateExtraArticle(this.extraArticleId, {
        Quantity: this.quantity,
        Comment: this.comment,
      });
    } else {
      await this.mooringOfferService.addExtraArticle(this.mooringId, {
        MooringArticleProductId: this.articleProductId,
        Quantity: this.quantity,
        Comment: this.comment,
      });
    }

    await this.dialogController.ok();
  }

  public getSelectedArticleDetails(o) {
    console.log(o);
    return {
      id: 0,
      title: 'test',
    };
  }

  protected async onCancel() {
    await this.dialogController.cancel();
  }
}
